import {BankLineClassification, TransactionDirection} from '@sollapay/enums';

export const FEES_BALANCE = '@Fees';
export const INTEREST_BALANCE = '@Interest';
export const REVENUE_BALANCE = '@Revenue';

export interface BankLineClassificationSpec {
  direction: TransactionDirection;
  counterparty: typeof FEES_BALANCE | typeof INTEREST_BALANCE | typeof REVENUE_BALANCE;
}

/** Every classification is Sollapay's own money, so each books against the bank's house balance. */
export const BANK_LINE_CLASSIFICATION_SPECS: Record<
  BankLineClassification,
  BankLineClassificationSpec
> = {
  [BankLineClassification.BANK_FEE]: {
    direction: TransactionDirection.DEBIT,
    counterparty: FEES_BALANCE
  },
  [BankLineClassification.BANK_FEE_REFUND]: {
    direction: TransactionDirection.CREDIT,
    counterparty: FEES_BALANCE
  },
  [BankLineClassification.INTEREST_EARNED]: {
    direction: TransactionDirection.CREDIT,
    counterparty: INTEREST_BALANCE
  },
  [BankLineClassification.COMPANY_TRANSFER_OUT]: {
    direction: TransactionDirection.DEBIT,
    counterparty: REVENUE_BALANCE
  },
  [BankLineClassification.COMPANY_TRANSFER_IN]: {
    direction: TransactionDirection.CREDIT,
    counterparty: REVENUE_BALANCE
  }
};

export function getClassificationsForDirection(
  direction: TransactionDirection
): BankLineClassification[] {
  return Object.values(BankLineClassification).filter(
    classification => BANK_LINE_CLASSIFICATION_SPECS[classification].direction === direction
  );
}

export function isClassificationApplicable(params: {
  classification: BankLineClassification;
  direction: TransactionDirection;
}): boolean {
  return BANK_LINE_CLASSIFICATION_SPECS[params.classification].direction === params.direction;
}

/** A debit moves money out of the house balance; a credit moves money into it. */
export function resolveClassificationBooking(params: {
  classification: BankLineClassification;
  houseBalanceId: string;
}): {sourceBalanceId: string; destinationBalanceId: string} {
  const {direction, counterparty} = BANK_LINE_CLASSIFICATION_SPECS[params.classification];
  return direction === TransactionDirection.DEBIT
    ? {sourceBalanceId: params.houseBalanceId, destinationBalanceId: counterparty}
    : {sourceBalanceId: counterparty, destinationBalanceId: params.houseBalanceId};
}
